<template>
  <div
    v-if="title"
    class="c-social-media l-flex l-flex--column l-flex--align-start u-margin-bottom-medium"
  >
    <h4 class="t-heading-5 u-margin-bottom-small">
      {{ title }}
    </h4>
    <div class="l-flex">
      <div class="c-social-media__platform">
        <a
          href="http://www.facebook.com/EnsoRings"
          target="_blank"
        >
          <svg
            width="31px"
            height="31px"
            viewBox="0 0 31 31"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>74BDB2D0-B4F6-46E5-80C7-3AAC21A0CFBD</title>

            <g
              id="Navigation"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="M-Nav"
                transform="translate(-96.000000, -907.000000)"
                fill="#022840"
                fill-rule="nonzero"
              >
                <g
                  id="Group"
                  transform="translate(96.000000, 907.000000)"
                >
                  <g id="Icon_facebook">
                    <path
                      id="Shape"
                      d="M15.5,0 C6.92941176,0 0,6.92941176 0,15.5 C0,24.0705882 6.92941176,31 15.5,31 C24.0705882,31 31,24.0705882 31,15.5 C31,6.92941176 24.0705882,0 15.5,0 Z M20.3323529,8.93529412 L18.6,8.93529412 C17.2323529,8.93529412 16.9588235,9.57352941 16.9588235,10.5764706 L16.9588235,12.6735294 L20.2411765,12.6735294 L19.7852941,16.0470588 L16.8676471,16.0470588 L16.8676471,24.6176471 L13.4029412,24.6176471 L13.4029412,16.0470588 L10.4852941,16.0470588 L10.4852941,12.6735294 L13.4029412,12.6735294 L13.4029412,10.2117647 C13.4029412,7.38529412 15.1352941,5.83529412 17.6882353,5.83529412 C18.8735294,5.83529412 19.9676471,5.92647059 20.2411765,5.92647059 L20.2411765,8.93529412 L20.3323529,8.93529412 Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
      <div class="c-social-media__platform">
        <a
          href="http://www.twitter.com/EnsoRings"
          target="_blank"
        >
          <svg
            width="31px"
            height="31px"
            viewBox="0 0 31 31"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>A368C976-FC99-4A17-A472-3F41A278550B</title>

            <g
              id="Navigation"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="M-Nav"
                transform="translate(-147.000000, -907.000000)"
                fill="#022840"
                fill-rule="nonzero"
              >
                <g
                  id="Group"
                  transform="translate(96.000000, 907.000000)"
                >
                  <g
                    id="Icon_Twitter"
                    transform="translate(51.000000, 0.000000)"
                  >
                    <path
                      id="Shape"
                      d="M15.5,0 C6.92941176,0 0,6.92941176 0,15.5 C0,24.0705882 6.92941176,31 15.5,31 C24.0705882,31 31,24.0705882 31,15.5 C31,6.92941176 24.0705882,0 15.5,0 Z M22.7941176,12.3088235 L22.7941176,12.7647059 C22.7941176,17.2323529 19.3294118,22.4294118 13.1294118,22.4294118 C11.2147059,22.4294118 9.39117647,21.8823529 7.93235294,20.8794118 C8.20588235,20.9705882 8.47941176,20.9705882 8.75294118,20.9705882 C10.3941176,20.9705882 11.8529412,20.4235294 12.9470588,19.5117647 C11.4882353,19.5117647 10.2117647,18.5088235 9.75588235,17.1411765 C9.93823529,17.1411765 10.2117647,17.2323529 10.3941176,17.2323529 C10.6676471,17.2323529 11.0323529,17.2323529 11.3058824,17.1411765 C9.75588235,16.8676471 8.57058824,15.4088235 8.57058824,13.7676471 C9.02647059,14.0411765 9.57352941,14.1323529 10.1205882,14.2235294 C9.20882353,13.5852941 8.57058824,12.5823529 8.57058824,11.3970588 C8.57058824,10.7588235 8.75294118,10.2117647 9.02647059,9.66470588 C10.6676471,11.7617647 13.2205882,13.0382353 16.0470588,13.2205882 C15.9558824,12.9470588 15.9558824,12.6735294 15.9558824,12.4 C15.9558824,10.4852941 17.5058824,9.02647059 19.3294118,9.02647059 C20.3323529,9.02647059 21.1529412,9.48235294 21.7911765,10.1205882 C22.6117647,9.93823529 23.3411765,9.66470588 23.9794118,9.3 C23.7058824,10.1205882 23.1588235,10.7588235 22.5205882,11.2147059 C23.25,11.1235294 23.8882353,10.9411765 24.4352941,10.6676471 C24.0705882,11.2147059 23.5235294,11.8529412 22.7941176,12.3088235 L22.7941176,12.3088235 Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
      <div class="c-social-media__platform">
        <a
          href="http://www.instagram.com/EnsoRings"
          target="_blank"
        >
          <svg
            width="31px"
            height="31px"
            viewBox="0 0 31 31"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>1D2E9912-5F18-42BE-A9B0-B5960D3B4D16</title>

            <g
              id="Navigation"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="M-Nav"
                transform="translate(-198.000000, -907.000000)"
                fill="#022840"
                fill-rule="nonzero"
              >
                <g
                  id="Group"
                  transform="translate(96.000000, 907.000000)"
                >
                  <g
                    id="Icon_instagram"
                    transform="translate(102.000000, 0.000000)"
                  >
                    <path
                      id="Shape"
                      d="M23.25,9.66470588 C23.0676471,9.20882353 22.8852941,8.84411765 22.5205882,8.47941176 C22.1558824,8.11470588 21.8823529,7.93235294 21.3352941,7.75 C20.9705882,7.65882353 20.4235294,7.47647059 19.5117647,7.38529412 C18.5088235,7.38529412 18.1441176,7.29411765 15.5,7.29411765 C12.8558824,7.29411765 12.4911765,7.29411765 11.4882353,7.38529412 C10.4852941,7.38529412 10.0294118,7.56764706 9.66470588,7.75 C9.11764706,7.93235294 8.84411765,8.11470588 8.47941176,8.47941176 C8.11470588,8.84411765 7.93235294,9.11764706 7.75,9.66470588 C7.65882353,10.0294118 7.47647059,10.5764706 7.38529412,11.4882353 C7.38529412,12.4911765 7.29411765,12.8558824 7.29411765,15.5 C7.29411765,18.1441176 7.29411765,18.5088235 7.38529412,19.5117647 C7.38529412,20.5147059 7.56764706,20.9705882 7.75,21.3352941 C7.93235294,21.7911765 8.11470588,22.1558824 8.47941176,22.5205882 C8.84411765,22.8852941 9.11764706,23.0676471 9.66470588,23.25 C10.0294118,23.3411765 10.5764706,23.5235294 11.4882353,23.6147059 C12.5823529,23.7058824 12.8558824,23.7058824 15.5,23.7058824 C18.1441176,23.7058824 18.5088235,23.7058824 19.5117647,23.6147059 C20.5147059,23.6147059 20.9705882,23.4323529 21.3352941,23.25 C21.7911765,23.0676471 22.1558824,22.8852941 22.5205882,22.5205882 C22.8852941,22.1558824 23.0676471,21.8823529 23.25,21.3352941 C23.3411765,20.9705882 23.5235294,20.4235294 23.6147059,19.5117647 C23.7058824,18.4176471 23.7058824,18.1441176 23.7058824,15.5 C23.7058824,12.8558824 23.7058824,12.4911765 23.6147059,11.4882353 C23.5235294,10.4852941 23.4323529,9.93823529 23.25,9.66470588 Z M15.5,20.6058824 C12.6735294,20.6058824 10.3941176,18.3264706 10.3941176,15.5 C10.3941176,12.6735294 12.6735294,10.3941176 15.5,10.3941176 C18.3264706,10.3941176 20.6058824,12.6735294 20.6058824,15.5 C20.6058824,18.3264706 18.3264706,20.6058824 15.5,20.6058824 Z M20.7882353,11.3970588 C20.15,11.3970588 19.6029412,10.85 19.6029412,10.2117647 C19.6029412,9.57352941 20.15,9.02647059 20.7882353,9.02647059 C21.4264706,9.02647059 21.9735294,9.57352941 21.9735294,10.2117647 C21.9735294,10.85 21.5176471,11.3970588 20.7882353,11.3970588 Z M15.5,0 C6.92941176,0 0,6.92941176 0,15.5 C0,24.0705882 6.92941176,31 15.5,31 C24.0705882,31 31,24.0705882 31,15.5 C31,6.92941176 24.0705882,0 15.5,0 Z M25.4382353,19.6029412 C25.3470588,20.6970588 25.2558824,21.4264706 24.9823529,22.0647059 C24.7088235,22.7029412 24.3441176,23.25 23.7970588,23.7970588 C23.25,24.3441176 22.7029412,24.7088235 22.0647059,24.9823529 C21.4264706,25.2558824 20.6970588,25.4382353 19.6029412,25.4382353 C18.5088235,25.5294118 18.2352941,25.5294118 15.5,25.5294118 C12.7647059,25.5294118 12.4911765,25.5294118 11.3970588,25.4382353 C10.3029412,25.3470588 9.57352941,25.2558824 8.93529412,24.9823529 C8.29705882,24.7088235 7.75,24.3441176 7.20294118,23.7970588 C6.65588235,23.25 6.29117647,22.7029412 6.01764706,22.0647059 C5.74411765,21.4264706 5.56176471,20.6970588 5.56176471,19.6029412 L5.56176471,15.5 C5.56176471,12.7647059 5.56176471,12.4911765 5.65294118,11.3970588 C5.74411765,10.3029412 5.83529412,9.57352941 6.10882353,8.93529412 C6.38235294,8.29705882 6.74705882,7.75 7.29411765,7.20294118 C7.84117647,6.65588235 8.38823529,6.29117647 9.02647059,6.01764706 C9.66470588,5.74411765 10.3941176,5.56176471 11.4882353,5.56176471 L15.5,5.56176471 C18.2352941,5.56176471 18.5088235,5.56176471 19.6029412,5.65294118 C20.6970588,5.74411765 21.4264706,5.83529412 22.0647059,6.10882353 C22.7029412,6.38235294 23.25,6.74705882 23.7970588,7.29411765 C24.3441176,7.84117647 24.7088235,8.38823529 24.9823529,9.02647059 C25.2558824,9.66470588 25.4382353,10.3941176 25.4382353,11.4882353 C25.5294118,12.5823529 25.5294118,12.8558824 25.5294118,15.5911765 C25.4382353,18.2352941 25.4382353,18.5088235 25.4382353,19.6029412 Z M15.5,12.2176471 C13.6764706,12.2176471 12.2176471,13.6764706 12.2176471,15.5 C12.2176471,17.3235294 13.6764706,18.7823529 15.5,18.7823529 C17.3235294,18.7823529 18.7823529,17.3235294 18.7823529,15.5 C18.7823529,13.6764706 17.3235294,12.2176471 15.5,12.2176471 Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
      <div class="c-social-media__platform">
        <a
          href="http://www.pinterest.com/EnsoRings"
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
          >
            <title>Icon_pinterest</title>

            <g
              id="Navigation"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="M-Nav"
                transform="translate(-249.000000, -908.000000)"
                fill="#022840"
                fill-rule="nonzero"
              >
                <g
                  id="Group"
                  transform="translate(96.000000, 907.000000)"
                >
                  <g
                    id="Icon_pinterest"
                    transform="translate(153.000000, 1.000000)"
                  >
                    <path
                      id="Path"
                      d="M15.082579,0 C6.92342281,0 0.308548009,6.60401003 0.308548009,14.749765 C0.308548009,21.0017231 4.19965083,26.3432018 9.69583357,28.491933 C9.56207691,27.3265194 9.45263965,25.5298402 9.74447236,24.2551692 C10.0119857,23.1018954 11.4711492,16.9227757 11.4711492,16.9227757 C11.4711492,16.9227757 11.0334002,16.0365758 11.0334002,14.7376253 C11.0334002,12.6860119 12.2250504,11.1564066 13.7085334,11.1564066 C14.9731418,11.1564066 15.5811266,12.1033051 15.5811266,13.2322995 C15.5811266,14.4948308 14.7785866,16.3886278 14.3529973,18.1488878 C14.0003661,19.6177945 15.0947387,20.8196272 16.5417426,20.8196272 C19.168237,20.8196272 21.1867466,18.0517701 21.1867466,14.0699405 C21.1867466,10.5372807 18.6453701,8.07291667 15.0096209,8.07291667 C10.8023659,8.07291667 8.33394758,11.2171053 8.33394758,14.4705514 C8.33394758,15.7330827 8.82033544,17.0927318 9.42832025,17.833255 C9.54991722,17.9789317 9.56207691,18.1124687 9.52559782,18.2581454 C9.41616056,18.7194549 9.16080694,19.727052 9.11216815,19.9334273 C9.05136967,20.2005013 8.89329362,20.2611999 8.6136206,20.1276629 C6.76534676,19.2657425 5.61017561,16.5828634 5.61017561,14.4098528 C5.61017561,9.76033835 8.99057119,5.48715539 15.3744118,5.48715539 C20.4936439,5.48715539 24.4820243,9.12907268 24.4820243,14.0092419 C24.4820243,19.0957863 21.2718645,23.1868734 16.8214156,23.1868734 C15.325773,23.1868734 13.9152482,22.4099311 13.44102,21.487312 C13.44102,21.487312 12.6992786,24.3037281 12.5168831,24.9956924 C12.1885713,26.2825031 11.2887538,27.8849467 10.680769,28.8682644 C12.0669744,29.2931548 13.5261379,29.5238095 15.0582597,29.5238095 C23.2174159,29.5238095 29.8323575,22.9197995 29.8323575,14.7740445 C29.8566101,6.60401003 23.2417353,0 15.082579,0 Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Social",
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.c-social-media {
  display: inline-block;
  &__platform {
    &:not(:last-child) {
      margin-right: rem(10px);
    }
  }
}
</style>
